export default __webpack_public_path__ + "static/media/evento-1.6aa1db8a.jpg";